﻿import React, { useEffect } from 'react';
import { createFocusTrap } from 'focus-trap';

import LockOverflowScroll from '../../../../../Resources/Scripts/_Shared/hooks/useLockBodyScroll'

const MapHeaderWidget = ({ facilitySearchContext, setFacilitySearchContext, mapContainerRef }) => {
  LockOverflowScroll();

  const lang = { ...facilitySearchContext.localization.headings, ...facilitySearchContext.localization.inputs };
  const closeMapViewHandler = () => setFacilitySearchContext({ ...facilitySearchContext, mapViewOpen: false });

  useEffect(() => {
		//Focus trap

		const overlayFocusTrap = createFocusTrap(mapContainerRef.current);
		overlayFocusTrap.activate();

		return () => { overlayFocusTrap.deactivate(); }
  }, [])

  return (
    <div className="facilitysearchpage__map__heading">
      <button aria-label={lang.showonmapclose} onClick={closeMapViewHandler}></button>
      <span>{lang.showonmapoverlay}</span>
    </div>
  )
}

export default MapHeaderWidget;
